import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const StudentDecleration = () => {
  const [previewImage, setpreviewImage] = useState(null);

  var user = useSelector((state) => state.user.user);

  // var admin = localStorage.getItem('admin');
  var userClickedByAdmin = useSelector(
    (state) => state.adminClickedUser.clickedUser
  );
  var loggedInData = null;

  if (user) {
    loggedInData = user;
  } else if (userClickedByAdmin) {
    loggedInData = userClickedByAdmin;
  } else {
    console.log("No user logged in or admin has not clicked any user");
    // Handle the case where no one is logged in
  }
  const {
    courseName,
    name,
    address,
    candidateNumber,
    email,
    studentSignature,
  } = loggedInData;

  const getMimeType = (imageUrl) => {
    // You may need to inspect the base64 string or use additional metadata if available
    if (imageUrl.startsWith("/9j/")) {
      return "image/jpeg";
    } else if (imageUrl.startsWith("iVBORw0KGgo")) {
      return "image/png";
    } else if (imageUrl.startsWith("R0lGODlh")) {
      return "image/gif";
    }
    return "image/jpeg"; // Default to JPEG if unknown
  };
  useEffect(() => {
    if (studentSignature) {
      const mimeType = getMimeType(studentSignature);
      const dataUrl = `data:${mimeType};base64,${studentSignature}`;
      // setPreviewPerformance(dataUrl)
      setpreviewImage(dataUrl);
    }
  }, [studentSignature]);

  return (
    <div>
      <div className="lg:mt-5 space-y-5">
        <p className="font-poppins text-[14px] text-[#11232E] leading-5">
          I hereby certify that the internship report I submitted to the Ten
          Hill Education's Training Qualification, endorsed {courseName} in
          partial fulfillment of the requirement is entirely original work on my
          part and has not previously been submitted to any other education
          institution.
        </p>

        <p className="font-poppins  text-[14px] text-[#11232E] leading-5    ">
          I further certify that no part of this text in whole or in part, has
          been taken from any previous work produced by other students or
          scholars.{" "}
        </p>
      </div>
      <div className="flex flex-col gap-4 mt-12 rounded-md">
        <div className="flex flex-col space-y-2 ">
          <span className="font-poppins text-[#11232E] text-[14px] font-semibold ">
            {name}
          </span>
          <span className="font-poppins  text-[#11232E] text-[14px] ">
            {address}
          </span>
          <span className="font-poppins  text-[#11232E] text-[14px] ">
            {candidateNumber}
          </span>
          <span className="font-poppins  text-[#11232E] text-[14px] ">
            {address}
          </span>
          <span className="font-poppins  text-[#11232E] text-[14px] ">
            {email}
          </span>
        </div>
        <div className="flex items-center">
          {previewImage && (
            <img src={previewImage} alt="noimg" className="h-24" />
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentDecleration;
